import { render, staticRenderFns } from "./LoginToFollowDialog.vue?vue&type=template&id=0ae62bea"
import script from "./LoginToFollowDialog.vue?vue&type=script&lang=ts"
export * from "./LoginToFollowDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports